// webpackでlib.jsとして結合するために、各種ライブラリをここに定義
global.$ = global.jQuery = require('jquery')
global.moment = require('moment')
global._ = require('lodash')
require('moment/locale/ja.js')
window.Highcharts = require('highcharts')
require('highcharts/highcharts-more.js')(window.Highcharts)
require('../libs/jquery-date-range-picker/jquery.daterangepicker_custom.js')
require('highcharts/modules/exporting')(window.Highcharts)
